import { Accordion, AccordionDetails, AccordionSummary, Chip, Stack, Typography } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import moment from "moment";
import SessionForm from "./SessionForm";

export default function SessionCard({session, chapters, expanded, onToggle, onSave, onDelete}){

    const program = session.program || {}

    const count = Object.keys(program).length

    const period = [session.start, session.end]
        .filter(Boolean)
        .map(d => moment(d).format('DD/MM/YYYY'))
        .join(' – ')

    return <Accordion
        expanded={expanded}
        onChange={onToggle}
        disableGutters
        variant='outlined'
        sx={{borderRadius: 1, '&:before': {display: 'none'}}}
    >

        <AccordionSummary expandIcon={<ExpandMore />}>

            <Stack direction='row' spacing={2} alignItems='center' flexWrap='wrap' sx={{flex: 1, pr: 2}}>

                <Typography sx={{flex: 1, minWidth: 180}}>{session.title}</Typography>

                <Typography variant='body2' color='text.secondary'>{period}</Typography>

                <Chip
                    size='small'
                    label={count === 0 ? 'Toute la formation' : `${count} chapitre${count > 1 ? 's' : ''}`}
                />

            </Stack>

        </AccordionSummary>

        {/* Unmounted when folded, so reopening always shows the saved values */}
        <AccordionDetails>
            {expanded &&
                <SessionForm
                    session={session}
                    chapters={chapters}
                    onSave={onSave}
                    onDelete={onDelete}
                />
            }
        </AccordionDetails>

    </Accordion>
}
